export default __webpack_public_path__ + "static/media/banner_1.72833fe7.jpg";